import Layout, { Content } from 'antd/es/layout/layout';
import { useContext } from 'react';
import Header from 'src/components/NewFeatures/Header';
import ModernSidebar from 'src/components/v2/Sidebar/ModernSidebar';
import { AppContext } from 'src/contexts/app.context';
import styles from './MainLayout.module.scss';
import { useLocation } from 'react-router-dom';

interface Props {
  children?: React.ReactNode;
  hasSidebar?: boolean;
}

export default function MainLayout({ children }: Props) {
  const { isSidebarCollapsed } = useContext(AppContext);
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/erp';

  return (
    <main className={styles.mainLayout}>
      <Header />
      <Layout className=''>
        {!isHome && <ModernSidebar />}
        {children && (
          <Content
            className={`${styles.pageContent} ${isSidebarCollapsed ? styles.mainCollapsed : ''} ${
              isHome ? styles.hidden : ''
            }`}
          >
            <div className={styles.container}>{children}</div>
          </Content>
        )}
      </Layout>
    </main>
  );
}
